//@flow
import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import FilterButton from '../../../../elements/HorizontalFilter/FilterButton/FilterButton';
import {colors} from '../../../../assets/styles/colors';
import {useToggleFilter} from '../../utils/productFilters';

const useStyles = makeStyles(theme => ({
  filterItemContainer: {
    display: 'flex',

    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },

    '&::-webkit-scrollbar-track': {
      background: colors.grey200,
      borderRadius: '5px',
    },

    '&::-webkit-scrollbar-thumb': {
      background: colors.grey400,
      borderRadius: '5px',
    },
  },
  categoriesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '.5rem',
  },
}));

const filtersOptions = [
  {
    id: 'active',
    label: 'activados',
  },
  {
    id: 'inactive',
    label: 'desactivados',
  },
];

export default function StockFilter() {
  const {filter, resetFilters, toggleUniqueFilterValue} = useToggleFilter();

  const classes = useStyles();

  return (
    <div className={classes.filterItemContainer}>
      <div className={classes.categoriesContainer}>
        <FilterButton
          id="all"
          handleOnClick={resetFilters}
          selected={filter.value.length === 0}
          text="todos"
        />

        {filtersOptions.map((promotion, index: number) => (
          <FilterButton
            key={promotion.id}
            selected={filter.value.includes(promotion.id)}
            id={promotion.id}
            handleOnClick={() => {
              toggleUniqueFilterValue(promotion.id);
            }}
            text={promotion.label}
          />
        ))}
      </div>
    </div>
  );
}
